var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    {
      staticClass: "gh-card gh-card--design gh-card--design-board",
      class: { "gh-card--collapsed": _vm.collapsed },
    },
    [
      _vm._t("context-head"),
      _vm._v(" "),
      _c("div", { staticClass: "gh-card-design__row" }, [
        _c(
          "button",
          {
            staticClass: "gh-card__chevron",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$emit("toggle-collapse")
              },
            },
          },
          [
            _c("i", {
              class: _vm.collapsed ? "fa fa-chevron-up" : "fa fa-chevron-down",
              attrs: { "aria-hidden": "true" },
            }),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "gh-card-design__image" }, [
          _vm.card.output.url
            ? _c("img", {
                ref: "cardImage",
                staticClass: "gh-card__image",
                class: { "gh-dnd-source": _vm.canDrag },
                attrs: {
                  src: _vm.card.output.url,
                  alt: "",
                  draggable: _vm.canDrag,
                },
                on: { dragstart: _vm.onImageDragStart, dragend: _vm.onDragEnd },
              })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "gh-card-design__prompt-col" },
          [
            _c(
              "GenerationHistoryCardSlide",
              { attrs: { expanded: !_vm.collapsed } },
              [
                _c("div", { staticClass: "gh-card-design__prompt" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "gh-card-text__meta gh-card-text__meta--in-design",
                    },
                    [
                      _c("GenerationHistoryMetaRows", {
                        attrs: {
                          fields: _vm.metaFields,
                          variant: "detail",
                          "can-drag-fields": _vm.canDrag,
                          "drag-field-keys": _vm.missionDragKeys,
                          "row-key-prefix": `design-board-${_vm.card.item_id}`,
                        },
                        on: {
                          "field-drag-start": _vm.onMissionDragStart,
                          "field-drag-end": _vm.onDragEnd,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "gh-card-design__actions-col" },
          [
            _c("GenerationHistoryDesignCardActions", {
              attrs: {
                "is-favorite": _vm.card.is_favorite,
                "is-image-copied": _vm.isImageCopied,
                "is-copied": _vm.isCopied,
                "show-copy": true,
                "show-copy-prompt": false,
              },
              on: {
                "copy-image": function ($event) {
                  return _vm.$emit("copy-image", _vm.$refs.cardImage)
                },
                copy: function ($event) {
                  return _vm.$emit("copy")
                },
                download: function ($event) {
                  return _vm.$emit("download")
                },
                favorite: function ($event) {
                  return _vm.$emit("favorite")
                },
              },
            }),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }